<script setup>
import { Check, } from 'lucide-vue-next';
import {
  Primitive,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  useForwardProps,
} from 'radix-vue';
import { computed, } from 'vue';
import { selectItemVariants, } from './index';
import { cn, } from '@/utils/ShadcnUtil';

const props = defineProps({
  value: { type: [
    String, Number, Boolean, Object, Array,
  ], required: true },
  disabled: { type: Boolean, required: false },
  textValue: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  showCheckbox: { type: Boolean, required: false },
  variant: { type: String, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectItem
    v-bind="forwardedProps"
    :class="cn(selectItemVariants({ intent: props.variant }), props.class)"
  >
    <span
      v-if="showCheckbox"
      class="absolute left-2 flex h-3.5 w-3.5 items-center justify-center"
    >
      <SelectItemIndicator>
        <Check class="h-4 w-4" />
      </SelectItemIndicator>
    </span>

    <SelectItemText>
      <slot />
    </SelectItemText>
  </SelectItem>
</template>
